import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=2abd33f5"
import script from "./FormRadio.vue?vue&type=script&lang=ts"
export * from "./FormRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports